<div class="">
  <form [formGroup]="dynamicForm">
    <div *ngFor="let key of dynamicForm.controls | keyvalue" class="dynamic-form-container">
      <ng-container *ngIf="formData[key.key].show">
        <clr-input-container class="col-12 mt-0" *ngIf="!['client', 'company'].includes(formData[key.key].type)">

          <label>{{ formData[key.key]['displayName'] | titlecase }} <span class="required"
              *ngIf="formData[key.key]['required']">*</span></label>
          <input clrInput [type]="formData[key.key].type" [formControlName]="key.key"
            [max]="key.key.includes('date') ? '2200-12-31' : null" class="w-full" />
          <clr-control-error *clrIfError="'required'">Required</clr-control-error>
          <clr-control-error *clrIfError="'maxDateInvalid'">Invalid Date (max date allowed is
            12/31/2200)</clr-control-error>
        </clr-input-container>
        <div *ngIf="formData[key.key].type === 'client'" class="mb-2">
          <label class="clr-control-label">{{ formData[key.key]['displayName'] | titlecase }} <span class="required"
              *ngIf="formData[key.key]['required']">*</span></label>
          <app-customer-list [showAddButton]="false" (onCustomerSelect)="onOptionSelect($event, formData[key.key])">
          </app-customer-list>
        </div>
        <div *ngIf="formData[key.key].type === 'company'" class="mb-2">
          <label class="clr-control-label">{{ formData[key.key]['displayName'] | titlecase }} <span class="required"
              *ngIf="formData[key.key]['required']">*</span></label>
          <app-company-list [showAddButton]="false" [company]="company" [companyList]="companyList" (companyUpdate)="onOptionSelect($event, formData[key.key])" *ngIf="companyList"></app-company-list>
        </div>
      </ng-container>
    </div>

  </form>
  <button type="submit" (click)="onSubmit()" class="btn btn-primary mt-3">Submit</button>
</div>